import React, { useEffect } from "react";
import "./styles.scss";
import "./mobile.scss";
import { getLanguage } from "../../../utils/environment";
import { getCategoryById } from "../../CreateNewItem/CreateNewCategory/service/category.service";
import { getNewsByCategoryPage } from "../../news/service/news.service";
import { NewsCard, NewsGroup } from "../../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom";

// const categoryId = process.env.REACT_APP_HOT_NEWS || "67d841d3ec995c0cecc999c2";
// const categoryId = props.categoryId;
const pageCount = "3";
const lan = getLanguage();

const Index = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [news, setNews] = React.useState([]);
  const [menu, setMenu] = React.useState("");

  useEffect(() => {
    // const categoryId = props.categoryId;
    async function fetchPageData() {
      try {
        let res = await getCategoryById(props.categoryId);
        console.log(res);
        if (res?.data) {
          setMenu(res?.data);
          let response = await getNewsByCategoryPage(
            props.categoryId,
            pageCount,
            lan,
            props.news_id
          );
          console.log("response getNewsByCategoryPage::", response);
          if (response?.data) {
            setNews(response?.data?.news);
          } else {
            setNews([]);
          }
        } else {
          setNews([]);
        }

        setIsLoading(false);
      } catch (error) {
        console.log({ error });
        setIsLoading(false);
      }
    }
    setIsLoading(true);
    if (props.categoryId) {
      fetchPageData();
    }
  }, [props.categoryId, props.news_id]);

  return (
    <>
      <NewsGroup
        data={{
          titleName: menu?.name?.[lan] || "",
          linkName:
            lan === "en"
              ? "More " + menu?.name?.[lan]
              : "තවත් " + menu?.name?.[lan],
        }}
        onClickViewNews={() => {
          props.history.push("/" + props.categoryId);
          props.setMenuName(props.categoryId);
        }}
      >
        <div className="news-row">
          {isLoading && <NewsCard data={{ type: "loading", isBorder: true }} />}
          {!isLoading &&
            news
              .filter(
                (item) => item.title?.[lan] && item.title[lan].trim() !== ""
              )
              .map((item, index) => (
                <NewsCard
                  data={{ type: "small", isBorder: true }}
                  item={item}
                  onClick={() => {
                    // props.history.push("/news-view");
                    if (item?.keywords?.[lan]) {
                      props.history.push(
                        `/${item?.keywords?.[lan]}/${item?.news_id}`
                      );
                    } else {
                      const generatedSlug = item?.title?.[lan]
                        ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                        ?.replace(/\//g, "")
                        ?.replace(/\s*-\s*/g, " ")
                        ?.trim()
                        .split(/\s+/)
                        .slice(0, 5)
                        .join("-")
                        .replace(/-+/g, "-");
                      props.history.push(`/${generatedSlug}/${item?.news_id}`);
                    }
                  }}
                />
              ))}
        </div>
      </NewsGroup>
      {/* <NewsGroup
        data={{
          titleName: menu?.name?.[lan] || "",
          linkName:
            lan === "en"
              ? "More " + menu?.name?.[lan]
              : "තවත් " + menu?.name?.[lan],
        }}
      >
        {news.map((item, index) => (
          <div className={"ngw__body"}>
            <NewsCard
              key={index}
              data={{ type: "small", isBorder: true }}
              item={item}
              onClick={() => {
               //  props.history.push("/news-view");
              }}
            />
          </div>
        ))}
          <div className={"ngw__body"}>
          <NewsCard
            data={{ type: "medium", isBorder: false }}
            onClick={() => {
             //  props.history.push("/news-view");
            }}
          />
          <NewsCard
            data={{ type: "medium", isBorder: false }}
            onClick={() => {
             //  props.history.push("/news-view");
            }}
          />
        </div>
        <div className={"ngw__body"}>
          <NewsCard
            data={{ type: "medium", isBorder: false }}
            onClick={() => {
             //  props.history.push("/news-view");
            }}
          />
          <NewsCard
            data={{ type: "medium", isBorder: false }}
            onClick={() => {
             //  props.history.push("/news-view");
            }}
          />
        </div>
        <div className={"ngw__body"}>
          <NewsCard
            data={{ type: "medium", isBorder: false }}
            onClick={() => {
             //  props.history.push("/news-view");
            }}
          />
          <NewsCard
            data={{ type: "medium", isBorder: false }}
            onClick={() => {
             //  props.history.push("/news-view");
            }}
          />
        </div>
        <div className={"ngw__body"}>
          <NewsCard
            data={{ type: "medium", isBorder: false }}
            onClick={() => {
             //  props.history.push("/news-view");
            }}
          />
          <NewsCard
            data={{ type: "medium", isBorder: false }}
            onClick={() => {
             //  props.history.push("/news-view");
            }}
          />
        </div>
        <div className={"ngw__body"}>
          <NewsCard
            data={{ type: "medium", isBorder: false }}
            onClick={() => {
             //  props.history.push("/news-view");
            }}
          />
          <NewsCard
            data={{ type: "medium", isBorder: false }}
            onClick={() => {
             //  props.history.push("/news-view");
            }}
          />
        </div>
      </NewsGroup> */}
    </>
  );
};
export default withRouter(Index);
// export default Index;
